"use client";

import { useState, useEffect } from "react";
import CookieConsent from "react-cookie-consent";
import Link from "next/link";
import styles from "./CookieConsent.module.scss";

export default function CookieConsentBanner() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <CookieConsent
      disableStyles={true}
      location="bottom"
      cookieName="accepted_cookies_consent"
      expires={150}
      buttonText="Accept all cookies"
      declineButtonText="Essential only"
      enableDeclineButton
      containerClasses={styles.cookieConsent}
      buttonWrapperClasses={styles.buttonWrapper}
      buttonClasses={styles.acceptButton}
      declineButtonClasses={styles.declineButton}
      contentClasses={styles.content}
    >
      <span style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
        <span>
          <strong>We use cookies</strong> to keep you logged in,
          remember your preferences, and analyse site usage with Google Analytics.
          By clicking <em>Accept all cookies</em> you consent to our use of cookies.{" "}
          <Link href="/contact-us">
            Questions? Get in touch.
          </Link>
        </span>
      </span>
    </CookieConsent>
  );
}